export function getPlatform() {
  if (typeof navigator === "undefined") return "unknown";
  const userAgents = [navigator.platform.toLowerCase(), navigator.userAgent.toLowerCase()];
  // navigator.platform can't be spoofed
  if (userAgents.some((ua) => ua.includes("mac"))) return "macos";
  if (userAgents.some((ua) => ua.includes("win"))) return "windows";
  if (userAgents.some((ua) => ua.includes("x11"))) return "unix";
  if (userAgents.some((ua) => ua.includes("linux"))) return "linux";
  return "unknown";
}
